import React from "react";
import { AppBar, Toolbar } from "@mui/material";

import LeftHeader from "./Headercomponents/LeftHeader";
import RightHeader from "./Headercomponents/RightHeader";


import "./Header.css";

const Header = () => {
  return (
    <AppBar position="sticky" sx={{ boxShadow: "none" }}>
      <Toolbar
        sx={{
          px: { xs: 1, sm: 2 },
          py: 0,
          minHeight: { xs: 56, sm: 64 },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <LeftHeader />
        <RightHeader />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
